import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';

import { customerDrawerInitialState } from './customerDrawerSlice';

const selectCustomerState = (state?: RootState) =>
  state?.customerDrawer || customerDrawerInitialState;
export const selectCustomerDrawer = createSelector(
  [selectCustomerState],
  customerDrawer => customerDrawer
);
